import {useEffect} from 'react';
import {DocumentModel, VisibilitySet} from '@/engine';
import {ValidateSectionMode} from '@/types/document/store';
import {useDocumentUtils} from '../utils';

export function useRunValidationsOnDocumentModelChange(
  activeSection: string,
  documentModel: DocumentModel,
  visibilitySet: VisibilitySet,
) {
  const {store, valueResolver} = useDocumentUtils();

  useEffect(() => {
    store.getState().validateSection(activeSection, {
      documentModel,
      valueResolver,
      validateMode: ValidateSectionMode.OnlyTouchedFields,
    });

    const dependentSections = documentModel.sections.find(section => section.id === activeSection)?.displayWith ?? [];
    for (const dependentSection of dependentSections) {
      store.getState().validateSection(dependentSection, {
        documentModel,
        valueResolver,
        validateMode: ValidateSectionMode.OnlyTouchedFields,
      });
    }
  }, [activeSection, documentModel, visibilitySet, store, valueResolver]);
}
